import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const WhyHlcSection = () => {
  return (
    <section id="hlc-why8v2-react" aria-label="Why Choose HLC Lighting">
      <Navbar/>
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;800&display=swap"
        rel="stylesheet"
      />
      <style>{`
        :root {
          --hlc-magenta: #9b1f6c;
          --hlc-royal-plum: #542757;
        }

        #hlc-why8v2-react {
          margin-left: calc(50% - 50vw);
          margin-right: calc(50% - 50vw);
          position: relative;
          isolation: isolate;
          width: 100vw;
          color: #fff;
          font-family: "Open Sans", system-ui, Arial, sans-serif; /* added font-family */
          background:
            linear-gradient(135deg, rgba(84,39,87,.96) 0%, rgba(53,51,91,.96) 55%, rgba(20,19,32,.97) 100%),
            repeating-linear-gradient(-45deg, rgba(255,255,255,.04) 0 2px, rgba(255,255,255,0) 2px 10px);
          padding: clamp(44px, 7vw, 96px) 0;
          overflow: hidden;
        }

        #hlc-why8v2-react::before{
          content:"";
          position:absolute; inset:0 auto auto 0;
          width:100%; height:8px;
          background: linear-gradient(90deg, var(--hlc-magenta), #b12983 45%, var(--hlc-royal-plum));
        }

        #hlc-why8v2-react::after{
          content:"";
          position:absolute; inset:auto -20vw -25% -20vw; height:55%;
          background: radial-gradient(60vw 35vw at 50% 100%, rgba(155,31,108,.28), transparent 60%);
          pointer-events:none;
        }

        #hlc-why8v2-react .hlc-wrap {
          width: min(1320px, 94vw);
          margin-inline: auto;
        }

        .hlc-head{ text-align:center; max-width:80ch; margin:0 auto clamp(28px,5vw,48px); }
        .hlc-eyebrow{
          font-size:.82rem; letter-spacing:.28em; opacity:.9; text-transform:uppercase;
        }
        .hlc-title{
          margin:.15em 0 .15em; font-weight:900;
          font-size: clamp(30px,5.5vw,56px); line-height:1.02; letter-spacing:-.02em;
        }
        .hlc-accent{ color: var(--hlc-magenta); }
        .hlc-sub{ opacity:.92; margin:0; }

        .hlc-grid{
          display:grid;
          grid-template-columns: repeat(4, 1fr);
          gap: clamp(16px, 2.8vw, 26px);
          margin: clamp(22px,4vw,36px) 0 clamp(22px,4.5vw,40px);
        }

        .hlc-card{
          position: relative;
          background: linear-gradient(180deg, rgba(255,255,255,.10), rgba(255,255,255,.06));
          border:1px solid rgba(255,255,255,.24);
          padding: clamp(18px,2.8vw,24px);
          display:grid; gap:10px;
          transition: transform .25s ease, border-color .25s ease, background .25s ease, box-shadow .25s ease;
          border-radius:0;
          box-shadow:0 10px 22px rgba(0,0,0,.18);
          font-family: "Open Sans", system-ui, Arial, sans-serif; /* ensure cards also inherit font */
        }

        .hlc-card:hover{
          transform: translateY(-4px);
          border-color: rgba(255,255,255,.42);
          background: linear-gradient(180deg, rgba(255,255,255,.14), rgba(255,255,255,.10));
          box-shadow:0 18px 38px rgba(0,0,0,.28);
        }

        .hlc-glyph{ color:var(--hlc-magenta); line-height:0; }
        .hlc-card-title{ font-weight:800; margin:.15rem 0 0; }
        .hlc-card-text{ margin:0; opacity:.96; }
        .hlc-stripe{
          position:absolute; left:0; top:0; bottom:0; width:4px;
          background: linear-gradient(180deg, var(--hlc-magenta), #b12983);
        }

        .hlc-ribbon{
          display:grid; grid-template-columns: 1fr auto 1fr auto 1fr;
          align-items:center; gap: clamp(10px,2.2vw,20px);
          background: linear-gradient(90deg, rgba(255,255,255,.08), rgba(255,255,255,.04));
          border:1px solid rgba(255,255,255,.25);
          padding: clamp(14px,2.6vw,18px) clamp(14px,3vw,22px);
          box-shadow: 0 10px 26px rgba(0,0,0,.18);
          font-family: "Open Sans", system-ui, Arial, sans-serif;
        }

        .hlc-ribbon .stat{text-align:center;}
        .hlc-ribbon .num{ display:block; font-weight:900; font-size: clamp(18px,3.2vw,28px);}
        .hlc-ribbon .lab{ opacity:.92; font-size:.98rem;}
        .hlc-ribbon .sep{ width:1px; height:34px; background: rgba(255,255,255,.35); }

        .hlc-cta{ display:flex; gap:12px; justify-content:center; margin-top: clamp(18px,4vw,34px); }
        .hlc-btn{
          display:inline-flex; align-items:center; justify-content:center;
          padding:14px 22px; font-weight:900; letter-spacing:.25px; text-decoration:none;
          border:2px solid transparent; border-radius:0; transition:.2s ease;
          font-family: "Open Sans", system-ui, Arial, sans-serif;
        }
        .hlc-btn-primary{ background:var(--hlc-magenta); color:#fff; }
        .hlc-btn-primary:hover{ background:#b12983; }
        .hlc-btn-ghost{ background:transparent; color:#fff; border-color: rgba(255,255,255,.6); }
        .hlc-btn-ghost:hover{ border-color:#fff; }

        @media(max-width:1100px){
          .hlc-grid{ grid-template-columns: repeat(2, 1fr); }
          .hlc-ribbon{ grid-template-columns:1fr; gap:10px; text-align:center; }
          .hlc-ribbon .sep{ display:none; }
        }
        @media(max-width:560px){
          .hlc-grid{ grid-template-columns:1fr; }
          .hlc-head{text-align:left;}
          .hlc-wrap{ width:92vw; }
          .hlc-cta{ justify-content:flex-start; flex-wrap:wrap; }
        }
      `}</style>

      <div className="hlc-wrap">
        <header className="hlc-head">
          <div className="hlc-eyebrow">WHY CHOOSE</div>
          <h2 className="hlc-title">
            HLC Lighting<span className="hlc-accent">.</span>
          </h2>
          <p className="hlc-sub">
            Built for Pakistan. Energy-efficient LEDs, rock-solid warranty, and nationwide delivery you can count on.
          </p>
        </header>

        <div className="hlc-grid">
          <article className="hlc-card">
            <div className="hlc-glyph">
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M12 3l7 3v6c0 5-3.8 9.7-7 11-3.2-1.3-7-6-7-11V6l7-3z"></path>
                <path d="M9 12l2 2 4-4"></path>
              </svg>
            </div>
            <h3 className="hlc-card-title">2-Year Warranty</h3>
            <p className="hlc-card-text">Peace of mind on every purchase with quick replacement support.</p>
            <span className="hlc-stripe"></span>
          </article>

          <article className="hlc-card">
            <div className="hlc-glyph">
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M13 2L3 14h7l-1 8 12-15h-8l1-5z"></path>
              </svg>
            </div>
            <h3 className="hlc-card-title">Energy Efficient</h3>
            <p className="hlc-card-text">Save up to 85% electricity with high-efficacy LED drivers.</p>
            <span className="hlc-stripe"></span>
          </article>

          <article className="hlc-card">
            <div className="hlc-glyph">
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M3 6h11v7h-2M14 6h4l3 4v3h-2M7 19a2 2 0 110-4 2 2 0 010 4zm8 0a2 2 0 110-4 2 2 0 010 4z"></path>
              </svg>
            </div>
            <h3 className="hlc-card-title">Nationwide Delivery</h3>
            <p className="hlc-card-text">TCS / Leopards / M&P — usually 2–4 business days.</p>
            <span className="hlc-stripe"></span>
          </article>

          <article className="hlc-card">
            <div className="hlc-glyph">
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect x="3" y="10" width="18" height="11"></rect>
                <path d="M7 10V8a5 5 0 0110 0v2"></path>
                <circle cx="12" cy="15.5" r="1.8"></circle>
              </svg>
            </div>
            <h3 className="hlc-card-title">Secure Payments</h3>
            <p className="hlc-card-text">SSL checkout, COD, Easypaisa & JazzCash supported.</p>
            <span className="hlc-stripe"></span>
          </article>
        </div>

        <div className="hlc-ribbon" role="group" aria-label="HLC Numbers">
          <div className="stat"><span className="num">25,000+</span><span className="lab">Orders Delivered</span></div>
          <div className="sep"></div>
          <div className="stat"><span className="num">200+</span><span className="lab">Retail Partners</span></div>
          <div className="sep"></div>
          <div className="stat"><span className="num">ISO / CE</span><span className="lab">Compliance</span></div>
        </div>

        <div className="hlc-cta">
       <Link to="/shop" className="hlc-btn hlc-btn-primary">
  Shop Now
</Link>

<Link to="/dealer-portal" className="hlc-btn hlc-btn-ghost">
  Become a Dealer
</Link>
        </div>
      </div>
    </section>
  );
};

export default WhyHlcSection;
